<template>

  <div class="video-picker-container">
    <p class="section-title">Videos</p>

    <div class="videos-container" v-if="selectedVideos.length !== 0">

      <div class="videos-row">
        <p class="videos-column-title">ID</p>
        <p class="videos-column-title">Club 1</p>
        <p class="videos-column-title">Club 2</p>
        <div></div>
      </div>

      <div class="videos-row" v-for="video in selectedVideos" :key="video.id">
        <p>{{ video.id }}</p>
        <p>{{ video.club1Alias.toUpperCase() }}</p>
        <p>{{ video.club2Alias.toUpperCase() }}</p>
        <v-icon title="Remove" @click="removeVideo(video)">mdi-close-circle</v-icon>
      </div>

    </div>

    <v-layout justify-end="justify-end" row="row">
      <v-flex xs6="xs6">
        <v-text-field label="Video" placeholder="Video ID" v-model="videoID"></v-text-field>
      </v-flex>
      <v-flex xs3="xs3">
        <v-btn class="add-button" color="lightgrey" @click="addVideo">Add</v-btn>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>

  </div>

</template>

<script>

export default {
  name: 'VideoPicker',
  props: ['videosID'],
  data () {
    return {
      videoID: '',

      selectedVideos: []
    }
  },
  methods: {
    addVideo (videoid, addOnlyVideo) {
      if (this.videoID || (addOnlyVideo && videoid)) {
        this.$store.dispatch('getVideo', this.videoID || videoid)
          .then(resp => {
            if (this.selectedVideos.length !== 0) {
              for (const vid of this.selectedVideos) {
                if (vid.id === resp.id) {
                  alert('Video already selected')
                  this.videoID = null
                  return ''
                }
              }
            }
            this.selectedVideos.push(resp)
            this.$emit('videoSelected', resp, addOnlyVideo)
            this.videoID = null
          })
          .catch(() => {
            alert('Error selecting video')
          })
      }
    },
    removeVideo (video) {
      this.selectedVideos.splice(this.selectedVideos.indexOf(video), 1)
      this.$emit('videoRemoved', video)
    },
    clear () {
      this.videoID = ''
      this.selectedVideos = []
    }
  }
}

</script>

<style lang="scss" scoped>

p {
  margin: 0;
}

.video-picker-container {
  margin: 12px 0 24px 0;
}

.section-title {
  font-weight: bold;
  margin-bottom: 12px;
}

.videos-row {
  width: 100%;
  margin-bottom: 6px;
  display: grid;
  grid-template-columns: 30% 30% 30% 1fr;
  grid-column-gap: 6px;
}

.videos-column-title {
  color: grey;
}

</style>



// WEBPACK FOOTER //
// src/components/clips/VideoPicker.vue